export const INCENTIVES_PERMISSIONS = {
  VIEW: 'PricingAssistant.view_incentive',
  ADD: 'PricingAssistant.add_incentive',
  CHANGE: 'PricingAssistant.change_incentive',
  DELETE: 'PricingAssistant.delete_incentive',
};

export const INCENTIVES_EDIT_PERMISSIONS = [
  INCENTIVES_PERMISSIONS.ADD,
  INCENTIVES_PERMISSIONS.CHANGE,
  INCENTIVES_PERMISSIONS.DELETE,
];
